import api from "./api";

class InventoryService {
    getLots(params = {}) {
        return api.get("/api/inventory/lots/", { params });
    }

    createTransaction(data) {
        return api.post("/api/inventory/transactions/", data);
    }
}

export default new InventoryService();
